module.exports = __webpack_public_path__ + "static/media/rightarrow.73ce3052.svg";